exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2po2r{padding:10px 20px;line-height:20px;white-space:nowrap;text-align:left;position:relative;border-bottom:1px solid #d9d9d9}body.reader-night-mode ._2po2r{border-color:#2e2e2e}._2po2r:first-child{border-radius:4px 4px 0 0}._2po2r:last-child{border-radius:0 0 4px 4px;border-bottom:0}._2po2r:hover{background-color:#666;color:#fff}body.reader-night-mode ._2po2r:hover{background-color:#2e2e2e}._2po2r ._22XWG{margin-right:5px}.cRfUr{border-bottom:1px solid #d9d9d9}body.reader-night-mode .cRfUr{border-color:#2e2e2e}._20tIi{opacity:.3}", ""]);

// exports
exports.locals = {
	"item": "_2po2r",
	"icon": "_22XWG",
	"item-border": "cRfUr",
	"item-disabled": "_20tIi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/Menu/MenuItem/MenuItem.scss
// module id = jrrN
// module chunks = 8